import { Injectable } from '@angular/core';
import { get } from 'lodash';
import { Observable, of } from 'rxjs';

import { ProtocolDroidService } from '../protocol-droid/services/protocol-droid.service';
import { ToasterService } from '../toaster/toaster.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorsService {
  constructor(private toasterService: ToasterService, private protocolDroidService: ProtocolDroidService) {}

  public handlePromise =
    <T>(defaultValue?: T) =>
    (response: any): Promise<T> => {
      console.log('Promise Error Handling -> ', response);
      const message = this.buildErrorMessage(response);
      return this.toasterService
        .showToast('error', {
          title: this.protocolDroidService.translate('misc.modals.error-title'),
          message
        })
        .then(() => defaultValue);
    };

  public handleObservable = <T>(response: any, fallbackResponse: T): Observable<T> => {
    console.log('Observable Error Handling -> ', response);
    const message = this.buildErrorMessage(response);
    /* Hiding spinner just in case */
    this.toasterService.showToast('error', {
      title: this.protocolDroidService.translate('misc.errors.intro'),
      message
    });
    return of(fallbackResponse);
  };

  private buildErrorMessage(response: any): string {
    if (response.status === 404 && !get(response, 'error.code')) {
      return this.protocolDroidService.translate('misc.errors.not-found', 'The resource could not be found.');
    } else if (response.status === 0) {
      return this.protocolDroidService.translate('misc.errors.no-contact', 'Cannot contact server.');
    } else if (get(response, 'error.code')) {
      return (
        this.protocolDroidService.translate('errors.label', 'Error') +
        ' ' +
        get(response, 'error.code') +
        '</b>' +
        ' ' +
        this.protocolDroidService.translate('errors.' + get(response, 'error.code'), 'Errors with Ideta code') +
        '\n' +
        this.protocolDroidService.translate('errors.original-message', 'Original message: ') +
        `${get(response, 'error.message')}`
      );
    } else {
      return (
        (response.error && response.error.message) ||
        (response.message !== 'INTERNAL' && response.message) ||
        this.protocolDroidService.translate('misc.errors.unknown-short', 'Unknown Error')
      );
    }
  }
}
